import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import * as api from "../api";

// Phân quyền: 1 = admin (toàn quyền), 2 = operator (pm2 + app pid), 3 = guest (chỉ xem).
const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // { uid, name, displayName, role } | null
  const [isGuest, setIsGuest] = useState(false);
  const [ready, setReady] = useState(false);

  // Khôi phục phiên từ token đã lưu (xác thực lại với backend)
  useEffect(() => {
    const t = api.getToken();
    if (!t) {
      setReady(true);
      return;
    }
    api
      .getMe()
      .then((u) => setUser(u))
      .catch(() => {
        try {
          localStorage.removeItem(api.TOKEN_KEY);
        } catch {
        /* localStorage không khả dụng — bỏ qua */
      }
      })
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (username, password) => {
    const { ok, data } = await api.login(username, password);
    if (ok && data.token) {
      try {
        localStorage.setItem(api.TOKEN_KEY, data.token);
      } catch {
        /* localStorage không khả dụng — bỏ qua */
      }
      setUser(data.user);
      setIsGuest(false);
    }
    return { ok, data };
  }, []);

  const logout = useCallback(() => {
    try {
      localStorage.removeItem(api.TOKEN_KEY);
    } catch {
      /* bỏ qua */
    }
    setUser(null);
    setIsGuest(false);
  }, []);

  const continueAsGuest = useCallback(() => setIsGuest(true), []);

  const role = user ? user.role || 3 : 3;
  const value = {
    user,
    role,
    isAdmin: role === 1,
    canOperate: role === 1 || role === 2, // pm2 start/stop + app pid
    isGuest: !user && isGuest,
    ready,
    authed: !!user || isGuest, // đã quyết định (đăng nhập hoặc chọn guest) → vào dashboard
    login,
    logout,
    continueAsGuest,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
